import { Theme } from '@mui/material/styles';

export const getMuiInputLabel = (theme: Theme): Record<string, unknown> => ({
  MuiInputLabel: {
    styleOverrides: {
      root: {
        color: theme.palette.common.black,
        fontSize: theme.typography.pxToRem(12),
        lineHeight: 1.33,

        '&.Mui-focused': {
          color: theme.palette.common.black,
        },
        '&.Mui-error': {
          color: theme.palette.error.main,
        },
      },

      formControl: {
        marginBottom: theme.spacing(0.5),
        position: 'relative',
      },

      shrink: {
        transform: 'scale(1)',
      },
    },
  },
});
